import { render, staticRenderFns } from "./ListPartners.vue?vue&type=template&id=e34b622e&"
import script from "./ListPartners.vue?vue&type=script&lang=js&"
export * from "./ListPartners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports